import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PaginatedCFTable } from 'commonTable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import * as actions from './redux/actions';
import { 
  generateTableColumnsMap,
  CustomPaginationFooter
 } from './';

export class CoachingTable extends Component {

  state = {
    columns: [],
    columnData: [],
    queryFilters: {
      Page: 1,
      PageSize: 25,
      SortOrder: 'desc',
      SortColumn: 'ID',
    },
  }

  componentDidMount = async () => {
    const {
      showAgentCoachings,
      actions: { fetchOpportunitiesAction, fetchReasonsAction, fetchStatusesAction, fetchKpisAction },
    } = this.props;

    if(!this.props.isDisabled) {
      await fetchOpportunitiesAction({ showAgentCoachings, queryFilters: this.state.queryFilters });
    }
    await fetchReasonsAction();
    await fetchStatusesAction();
    await fetchKpisAction();
  }

  componentDidUpdate = async (prevProps) => {
    const {
      kpis,
      reasons,
      statuses,
      showAgentCoachings,
      actions: { fetchOpportunitiesAction }
    } = this.props;

    if (prevProps.reasons !== reasons || prevProps.statuses !== statuses || prevProps.kpis !== kpis) {
      const columns = CoachingTable.createColumns(reasons, statuses, kpis);
      const columnData = generateTableColumnsMap(columns);

      this.setState({ columns, columnData });
    }

    if (prevProps.showAgentCoachings !== showAgentCoachings) {
      await fetchOpportunitiesAction({ showAgentCoachings, queryFilters: this.state.queryFilters });
    }
  }

  static createColumns = (reasons, statuses, kpis) => {
    if (!Array.isArray(reasons) || !Array.isArray(statuses) || !Array.isArray(kpis)) return [];
    const reasonOptions = reasons.map((ele, i) => {
      return (
        <option key={i} value={ele.id}>{ele.name}</option>
      );
    });

    const statusOptions = statuses.map((ele, i) => {
      return (
        <option key={i} value={ele.id}>{ele.name}</option>
      );
    });

    const kpiOptions = kpis.map((ele, i) => {
      return (
        <option key={i} value={ele.id}>{ele.name}</option>
      );
    });

    return [
      {
        Header: '',
        accessor: 'isOverdue',
        sortable: false,
        filterable: false,
        width: 50,
        style: { textAlign: 'center' },
        Cell: (row) => (
          <div className={ row.original.isOverdue ? 'overdue-icon' : 'overdue-icon--hidden' }>
            !
          </div>
        ),
      },
      {
        Header: 'ID',
        accessor: 'id',
        sortable: true,
        filterable: true,
        width: 80,
        operation: 'Equals',
        Cell: (row) => (
          <Link 
            className="id-link"
            to={`/AgentCoaching/Opportunity/${row.original.id}`}
          >
            {row.original.id}
          </Link>
        )
      },
      {
        Header: 'First Name',
        accessor: 'agentFirstName',
        sortable: true,
        filterable: true,
        width: 170,
        operation: 'Contains',
      },
      {
        Header: 'Last Name',
        accessor: 'agentLastName',
        sortable: true,
        filterable: true,
        width: 170,
        operation: 'Contains',
      },
      {
        Header: 'Status',
        accessor: 'statusId',
        sortable: true,
        filterable: true,
        width: 165,
        operator: 'Equals',
        Cell: row => row.original.status,
        filterMethod: (filter, row) => {
          return filter.value === 'None' ? null : filter.value;
        },
        Filter: ({ filter, onChange }) => 
          <select
            onChange={e => onChange(e.target.value)}
            style={{ width: "100%"}}
            value={ filter ? filter.value : "None" }
          >
            <option key={'all'} value="">All</option>
            { statusOptions }
          </select>
      },
      {
        Header: 'Overdue',
        accessor: 'overdueDays',
        sortable: true,
        filterable: false,
        width: 90,
        Cell: (row) => (
          <div
            className={row.original.isOverdue ? 'text-red' : ''}
          >
            {row.value}
          </div>
        )
      },
      {
        Header: 'Reason',
        accessor: 'reasonId',
        sortable: true,
        filterable: true,
        width: 175,
        Cell: row => row.original.reason,
        filterMethod: (filter, row) => {
          return filter.value === 'None' ? null : filter.value;
        },
        Filter: ({ filter, onChange }) => 
          <select
            onChange={e => onChange(e.target.value)}
            style={{ width: "100%"}}
            value={ filter ? filter.value : "None" }
          >
            <option key={'all'} value="">All</option>
            { reasonOptions }
          </select>
      },
      {
        Header: 'Target KPI',
        accessor: 'targetKpiId',
        sortable: true,
        filterable: true,
        width: 150,
        Cell: row => row.original.targetKpi,
        filterMethod: (filter, row) => {
          return filter.value === 'None' ? null : filter.value;
        },
        Filter: ({ filter, onChange }) => 
          <select
            onChange={e => onChange(e.target.value)}
            style={{ width: "100%"}}
            value={ filter ? filter.value : "None" }
          >
            <option key={'all'} value="">All</option>
            { kpiOptions }
          </select>
      },
      {
        Header: 'Date Created',
        accessor: 'dateCreated',
        sortable: true,
        filterable: false,
        width: 105,
      },
      {
        Header: 'Created By',
        accessor: 'createdBy',
        sortable: true,
        filterable: true,
        width: 170,
        operation: 'Contains',
      }
    ]
  }

  fetchTableData = (queryFilters) => {
    const { 
      showAgentCoachings,
      actions: { fetchOpportunitiesAction },
    } = this.props;
    this.setState({ queryFilters }, async () => {
      await fetchOpportunitiesAction({ showAgentCoachings, queryFilters });
    });
  }

  render() {
    const {
      fetchTableData,
      props: {
        isDisabled,
        opportunities: {
          data = [],
          Page,
          Pages,
          PageSize,
          TotalCount,
        }
      },
      state: {
        columns, 
        columnData
      }
    } = this;

    return (
      <PaginatedCFTable
        className="apcoaching-table"
        fetchData={(filter) => isDisabled ? null : fetchTableData(filter)}
        shouldInitialLoad
        defaultSortAccessor="ID"
        columnData={columnData}
        pageSize={PageSize}
        columns={columns}
        resizeable={false}
        totalCount={TotalCount}
        defaultSortAsc
        showFilterBar
        pages={Pages}
        data={isDisabled ? [] : data}
        filterable
        sortable
        filters={{
          Page,
          Pages,
          PageSize,
          TotalCount,
        }}
        useCustomPagination
        paginationComponent={CustomPaginationFooter}
      />
    );
  }
}

CoachingTable.propTypes = {
  opportunities: PropTypes.object,
  reasons: PropTypes.array,
  statuses: PropTypes.array,
  showAgentCoachings: PropTypes.bool.isRequired,
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    opportunities: state.agentCoaching.opportunities,
    reasons: state.agentCoaching.reasons,
    statuses: state.agentCoaching.statuses,
    kpis: state.agentCoaching.kpis,
    isTeamLead: state.common.user.teamManagerType === 0,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoachingTable);


// WEBPACK FOOTER //
// ./src/features/agent-coaching/CoachingTable.js